var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
var CaseApplyRecordService = /** @class */ (function () {
    function CaseApplyRecordService() {
    }
    /**
     * 获取所有审核记录
     */
    CaseApplyRecordService.prototype.getAllCaseApplyRecords = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.getAllCaseApplyRecords,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催申请
     */
    CaseApplyRecordService.prototype.applyCaseAssist = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyCaseAssist,
            data: data
        });
    };
    /**
     * 留案申请
     */
    CaseApplyRecordService.prototype.applyLeaveCase = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyLeaveCase,
            data: data,
        });
    };
    /**
     * 抢案共享
     */
    CaseApplyRecordService.prototype.applyRobCaseShare = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyRobCaseShare,
            data: data,
        });
    };
    /**
     * 抢案申请
     * @param data
     */
    CaseApplyRecordService.prototype.applyRobCase = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyRobCase,
            data: data,
        });
    };
    /**
     * 协催留案申请
     */
    CaseApplyRecordService.prototype.applyAssistLeaveCase = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyAssistLeaveCase,
            data: data,
        });
    };
    /**
     * 减免申请
     */
    CaseApplyRecordService.prototype.applyDerate = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyDerate,
            data: data,
        });
    };
    /**
     * 留案申请
     */
    CaseApplyRecordService.prototype.dealApply = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.dealApply,
            data: data,
        });
    };
    /**
     * 审批记录
     */
    CaseApplyRecordService.prototype.recordHistory = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.recordHistory,
            data: data,
        });
    };
    /**
     * 停催申请
     */
    CaseApplyRecordService.prototype.applyPauseCase = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyPauseCase,
            data: data,
        });
    };
    /**
     * 提前流转申请
     */
    CaseApplyRecordService.prototype.applyTurnCase = function (model) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyTurnCase,
            data: {
                applyCategory: 'TURN_CASE',
                caseIds: model.caseIds,
                turnGoal: model.turnSource,
                applyDescription: model.applyDescription,
                confirm: model.confirm,
            },
        });
    };
    /**
     * 委外回收-申请流转申请
     */
    CaseApplyRecordService.prototype.applyCirculationCase = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyCirculationCase,
            data: data,
        });
    };
    /**
     * 人工划扣
     */
    CaseApplyRecordService.prototype.applyRepay = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyRepay,
            data: data,
        });
    };
    /**
     * 停催激活
     */
    CaseApplyRecordService.prototype.applyPauseCaseActive = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.applyPauseCaseActive,
            data: data,
        });
    };
    /**
     * 审批类型设置列表
     */
    CaseApplyRecordService.prototype.checkApplyCategory = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.checkApplyCategory,
            data: data,
        });
    };
    /**
     * 审核管理-我的审核导出
     */
    CaseApplyRecordService.prototype.warehouseApprovalExport = function (data) {
        return this.netService.send({
            server: domainService.caseApplyRecordController.allCaseApplyExportRecords,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseApplyRecordService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyCaseAssist", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyLeaveCase", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyRobCaseShare", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyRobCase", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyAssistLeaveCase", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyDerate", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "dealApply", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyPauseCase", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyTurnCase", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyCirculationCase", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyRepay", null);
    __decorate([
        Debounce()
    ], CaseApplyRecordService.prototype, "applyPauseCaseActive", null);
    return CaseApplyRecordService;
}());
export { CaseApplyRecordService };
